var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',_vm._g(_vm._b({on:{"submit":function($event){$event.preventDefault();}}},'form',_vm.$attrs,false),_vm.mountEventListeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }